/* ============================================================
   Talleria Pro - Shared Landing Page JS
   ============================================================ */
(function () {
  'use strict';
  var doc = document.documentElement;
  if (!doc) return;
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.querySelector('.lp');
  if (!root) return;

  /* js-ready class for reveal animations */
  if (!prefersReduced) {
    requestAnimationFrame(function () { root.classList.add('js-ready'); });
  } else {
    root.classList.add('js-ready');
  }

  /* Intersection Observer for reveal */
  if (!prefersReduced && 'IntersectionObserver' in window) {
    var revealEls = root.querySelectorAll('.lp-reveal');
    if (revealEls.length) {
      var ro = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            ro.unobserve(e.target);
          }
        });
      }, { threshold: 0.15 });
      revealEls.forEach(function (el) { ro.observe(el); });
    }
  } else {
    root.querySelectorAll('.lp-reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Video toggle buttons */
  root.querySelectorAll('[data-video-toggle]').forEach(function (btn) {
    var video = btn.closest('.lp-demo__video, .lp-hero__media, figure')?.querySelector('video');
    if (!video) return;
    btn.addEventListener('click', function () {
      if (video.paused) { video.play(); btn.setAttribute('aria-pressed', 'true'); }
      else { video.pause(); btn.setAttribute('aria-pressed', 'false'); }
    });
  });

  /* Smooth scroll for anchor links */
  root.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (!id || id === '#') return;
      var target = root.querySelector(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
      }
    });
  });

  /* Sticky mobile buy bar */
  var mobileBuy = root.querySelector('[data-lp-mobile-buy]');
  if (mobileBuy) {
    var heroSection = root.querySelector('.lp-hero');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { mobileBuy.classList.remove('is-visible'); }
        else { mobileBuy.classList.add('is-visible'); }
      });
    }, { threshold: 0 });
    if (heroSection) observer.observe(heroSection);
  }

  /* Auto-pause videos when offscreen */
  if ('IntersectionObserver' in window) {
    var videos = root.querySelectorAll('video[data-autoloop-video]');
    if (videos.length) {
      var vo = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.play().catch(function(){}); }
          else { e.target.pause(); }
        });
      }, { threshold: 0.1 });
      videos.forEach(function (v) { vo.observe(v); });
    }
  }
})();
